import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { IAuction } from '../interfaces';
import { AuctionService } from '../services/auction.service';

/**
 * Resolves the auction on BOTH platforms. On the server the fetch goes through
 * {@link AuctionService.getAuction}'s SSR branch, which reads the document from
 * Firestore and hands it to the browser via TransferState (`Auction-<sid>-<aid>`) —
 * so the auction page is server-rendered with real content and the client
 * never re-fetches it.
 */
export const AuctionResolver: ResolveFn<IAuction | null> = async (route) => {
  const aid = route.paramMap.get('aid')!;
  const navigationAuction = inject(Router).getCurrentNavigation()?.extras.state?.['auction'] as
    | IAuction
    | undefined;
  if (
    navigationAuction?.aid === aid &&
    navigationAuction.increments != null &&
    typeof navigationAuction.manual_close === 'boolean' &&
    !!navigationAuction.origin_sid
  ) {
    return navigationAuction;
  }
  try {
    return await inject(AuctionService).getAuction(aid);
  } catch {
    // Missing/failed lookups fall through: the browser shows the not-found
    // dialog; the server renders the loading shell and lets the client retry.
    return null;
  }
};
